import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useUser } from './context/userContext';
import { useBuilding } from './context/buildingContext';
import { getBuildingBackground } from './utils/imageHelpers';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import DataUsage from './pages/DataUsage';
import BuildingSelector from './pages/BuildingSelector';
import { PasswordChange } from './pages/PasswordChange';
import SubUsers from './pages/SubUsers';
import Messages from './pages/Messages';
import SplashScreen from './pages/Splash';

const App: React.FC = () => {
  const { isLoggedIn } = useUser();
  const { buildingId } = useBuilding();

  const [showSplash, setShowSplash] = useState(true);

  // 1 sec splash
  useEffect(() => {
    const t = setTimeout(() => setShowSplash(false), 5000);
    return () => clearTimeout(t);
  }, []);

  // Dynamic background
  useEffect(() => {
    const appContainer = document.querySelector('.app-container') as HTMLElement;
    if (appContainer && !isLoggedIn) {
      const numericBuildingId = buildingId ? parseInt(buildingId, 10) : null;
      const backgroundImage = getBuildingBackground(numericBuildingId);

      if (backgroundImage) {
        appContainer.style.setProperty('--dynamic-background', `url(${backgroundImage})`);
      } else {
        appContainer.style.removeProperty('--dynamic-background');
      }
    }
  }, [buildingId, isLoggedIn]);

  return (
    <Router>
      <div className={`app-container ${isLoggedIn ? 'loggedIn' : 'loggedOut'}`}>
        {/* Splash overlay – mindent lefed, majd kifakul */}
        {showSplash && <SplashScreen src="/splash.gif" alt="Splash" />}

        <div className="container">
          <Routes>
            <Route path="/" element={isLoggedIn ? <BuildingSelector /> : <LoginPage />} />
            <Route path="/messages" element={isLoggedIn ? <Messages /> : <Navigate to="/" />} />
            <Route path="/dashboard" element={isLoggedIn ? <Dashboard /> : <Navigate to="/" />} />
            <Route path="/settings" element={isLoggedIn ? <Settings /> : <Navigate to="/" />} />
            <Route path="/data" element={isLoggedIn ? <DataUsage /> : <Navigate to="/" />} />
            <Route path="/password-change" element={isLoggedIn ? <PasswordChange /> : <Navigate to="/" />} />
            <Route path="/sub-users" element={isLoggedIn ? <SubUsers /> : <Navigate to="/" />} />
          </Routes>
        </div>

        {/* Amíg a splash látszik, ne jelenjen meg a Footer */}
        {!showSplash && <Footer />}
      </div>
    </Router>
  );
};

export default App;
